import React, { Suspense } from 'react';
import { Switch, Route } from "react-router-dom";
import Translate from './Translate';
import Storage from './utils/Storage';

//const ChartJs = React.lazy(() => import('../entita/materiale/progetto/BarChart'));

//const MaterialeSel = React.lazy(() => import('../entita/materiale/Sel'));

const Specifiche1 = React.lazy(() => import('../entita/Specifiche1'));
const Specifiche2 = React.lazy(() => import('../entita/Specifiche2'));
const Specifiche3 = React.lazy(() => import('../entita/Specifiche3'));
const Specifiche4 = React.lazy(() => import('../entita/Specifiche4'));
const GruppoutenteArea = React.lazy(() => import('../entita/anagrafica/gruppoutente/Area'));
const SuperGruppoArea = React.lazy(() => import('../entita/anagrafica/supergruppo/Area'));
const AccessoutenteArea = React.lazy(() => import('../entita/anagrafica/accessoutente/Area'));
const AccessoutenteLogArea = React.lazy(() => import('../entita/anagrafica/accessi/Area'));
const PermessoArea = React.lazy(() => import('../entita/anagrafica/permesso/Area'));
const PermessoMenuArea = React.lazy(() => import('../entita/anagrafica/permessomenu/Area'));

const LogoArea = React.lazy(() => import('../entita/materiale/logo/Area'));
const InternoArea = React.lazy(() => import('../entita/anagrafica/interno/Area'));
const ProgettoArea = React.lazy(() => import('../entita/materiale/progetto/Area'));
const ProgettoAreaT = React.lazy(() => import('../entita/materiale/progetto/AreaT'));
//const TerminatoArea = React.lazy(() => import('../entita/materiale/terminato/Area'));

const MatrecArea2 = React.lazy(() => import('../entita/materiale/matrecmat/Area'));
const MatClienteArea = React.lazy(() => import('../entita/materiale/cliente/Area'));


const ProgettoDistinta = React.lazy(() => import('../entita/materiale/progetto/Distinta'));
const ProgettoView = React.lazy(() => import('../entita/materiale/progetto/View'));
const ProgettoCharts = React.lazy(() => import('../entita/materiale/progetto/Chart'));
const ProgettoIndex = React.lazy(() => import('../entita/materiale/progetto/Indice'));
const ProgettoConsumi = React.lazy(() => import('../entita/materiale/progetto/Consumi'));
const ProgettoCiclovita = React.lazy(() => import('../entita/materiale/progetto/Ciclovita'));
const ProgettoCertificazione = React.lazy(() => import('../entita/materiale/progetto/Certificazione'));
const ProgettoCertificazioneView = React.lazy(() => import('../entita/materiale/progetto/CertificazioneView'));
const ProgettoStampa = React.lazy(() => import('../entita/materiale/progetto/Stampa'));


const ImportazioneArea = React.lazy(() => import('../entita/setup/importazione/Area'));

const ApplicazioneArea = React.lazy(() => import('../entita/setup/applicazione/Area'));
const AziendaClienteArea = React.lazy(() => import('../entita/anagrafica/userazienda/Area'));
const CategoriaArea = React.lazy(() => import('../entita/setup/categoria/Area'));
const AziendaArea = React.lazy(() => import('../entita/setup/azienda/Area'));
const BasematArea = React.lazy(() => import('../entita/setup/basemat/Area'));
const ColorazioneArea = React.lazy(() => import('../entita/setup/colorazione/Area'));
const CertAziArea = React.lazy(() => import('../entita/setup/certazi/Area'));
const TagArea = React.lazy(() => import('../entita/setup/tag/Area'));
const CertMatArea = React.lazy(() => import('../entita/setup/certmat/Area'));
const DurezzaArea = React.lazy(() => import('../entita/setup/durezza/Area'));
const FormatoArea = React.lazy(() => import('../entita/setup/formato/Area'));
const FinituraArea = React.lazy(() => import('../entita/setup/finitura/Area'));
const LucentezzaArea = React.lazy(() => import('../entita/setup/lucentezza/Area'));
const FinevitaArea = React.lazy(() => import('../entita/setup/finevita/Area'));
const TrasparenzaArea = React.lazy(() => import('../entita/setup/trasparenza/Area'));
const TecnologiaArea = React.lazy(() => import('../entita/setup/tecnologia/Area'));
const TextureArea = React.lazy(() => import('../entita/setup/texture/Area'));
const TipologiaArea = React.lazy(() => import('../entita/setup/tipologia/Area'));
const ProgettiConfronto = React.lazy(() => import('../entita/materiale/progetto/ConfrontaStampa'));
//const RapidoArea = React.lazy(() => import('./prove/grid'));
const CategoriaIvaArea = React.lazy(() => import('../entita/setup/categoriaiva/Area'));
const PagamentoGruppoArea = React.lazy(() => import('../entita/setup/pagamentogruppo/Area'));
const FtArea = React.lazy(() => import('../entita/ft/ft/Area'));
const ProdottoArea = React.lazy(() => import('../entita/ec/prodotto/Area'));
const OrdineArea = React.lazy(() => import('../entita/ec/ordine/Area'));
const FattureArea = React.lazy(() => import('../entita/ft/ft/Area'));
const EcConfArea = React.lazy(() => import('../entita/ec/conf/Area'));

//const ServizioArea = React.lazy(() => import('../entita/setup/servizio/Area'));

//const AssicurazioneArea = React.lazy(() => import('./entita/anagrafica/assicurazione/AssicurazioneArea'));
//const LiquidatoreArea = React.lazy(() => import('./entita/anagrafica/liquidatore/LiquidatoreArea'));
/*



const ConvenzioneArea = React.lazy(() => import('./entita/anagrafica/convenzione/ConvenzioneArea'));*/



const isSuperUser = Storage.getItem('user_level') === 'S';

function AnagraficaDirectView(props) {
    //la chiave è la parte di url dopo anagrafica
    const Cs = {
        interno: InternoArea,
    }
    const entitas = {
        interno: 'A1',
    }
    const entita = props.match.params.entita;
    const id = parseInt(props.match.params.id);
    const C = Cs[props.match.params.entita];
    const cProps = {
        selid: id,
        selactparams: { entita: entitas[entita], selareainit: 'view' },
    }
    if (!C) {
        return null;
    }
    return (
        <C {...cProps} />
    );
}

function setupDirectView(props) {
    if (!isSuperUser) {
        return false;
    }
    //la chiave e la parte di url dopo anagrafica
    const Cs = {
        applicazione: ApplicazioneArea,
        azienda: AziendaArea,
        materialebase: BasematArea,
        certificazioneazienda: CertAziArea,
        certificazionemateriale: CertMatArea,
        colorazione: ColorazioneArea,
        durezza: DurezzaArea,
        formato: FormatoArea,
        finevita: FinevitaArea,
        finitura: FinituraArea,
        lucentezza: LucentezzaArea,
        trasparenza: TrasparenzaArea,
        texture: TextureArea,
        tecnologia: TecnologiaArea,
        tipologia: TipologiaArea,
    }
    const id = parseInt(props.match.params.id);
    const C = Cs[props.match.params.entita];
    return (
        <C selid={id} selactparams={{ selareainit: 'view' }} />
    );
}
/*
function Home() {
    return (
        <h2>Home</h2>
    );
}*/

function ProgettoAction(props) {
    //  console.log(props);
    const itemid = parseInt(props.match.params.id);
    const action = props.match.params.action;
    if (action === 'bilanciomaterico') {
        return <ProgettoView itemid={itemid} />
    }
    if (action === 'distintabase') {
        return <ProgettoDistinta itemid={itemid} />
    }
    if (action === 'grafici') {
        return <ProgettoCharts itemid={itemid} />
    }
    if (action === 'indiceperformance') {
        return <ProgettoIndex itemid={itemid} />
    }
    if (action === 'consumi') {
        return <ProgettoConsumi itemid={itemid} />
    }
    if (action === 'ciclovita') {
        return <ProgettoCiclovita itemid={itemid} />
    }
    if (action === 'certificazione') {
        return <ProgettoCertificazione itemid={itemid} />
    }
    if (action === 'certificazionereport') {
        return <ProgettoCertificazioneView itemid={itemid} />
    }
    if (action === 'stampa') {
        return <ProgettoStampa itemid={itemid} />
    }
    return null;
}


function Homepage() {

    const readonly = Storage.getItem('readonly') === '1';

    return (
        <Suspense fallback={<div className="pt-5">
            <Translate chiave="LOADING" pacchetto="Site" />
        </div>}>
            <Switch>

                <Route path="/setup/:entita/:id" component={setupDirectView} />
                <Route path="/anagrafica/:entita/:id" component={AnagraficaDirectView} />

                {/*aree*/}

                {isSuperUser && <Route path="/anagrafica/interno" component={InternoArea} />}
                {isSuperUser && <Route path="/accesso/gruppoutente" component={GruppoutenteArea} />}
                {isSuperUser && <Route path="/accesso/gruppoazienda" component={SuperGruppoArea} />}
                {isSuperUser && <Route path="/accesso/accessoutente" component={AccessoutenteArea} />}
                {isSuperUser && <Route path="/accesso/storicoaccessi" component={AccessoutenteLogArea} />}
                {isSuperUser && <Route path="/accesso/permesso" component={PermessoArea} />}
                {isSuperUser && <Route path="/accesso/permessomenu" component={PermessoMenuArea} />}


                {isSuperUser && <Route path="/setup/applicazione" component={ApplicazioneArea} />}
                {isSuperUser && <Route path="/setup/categoria" component={CategoriaArea} />}
                {isSuperUser && <Route path="/setup/materialebase" component={BasematArea} />}
                {isSuperUser && <Route path="/setup/azienda" component={AziendaArea} />}
                {isSuperUser && <Route path="/setup/certificazioneazienda" component={CertAziArea} />}
                {isSuperUser && <Route path="/setup/certificazionemateriale" component={CertMatArea} />}
                {isSuperUser && <Route path="/setup/colorazione" component={ColorazioneArea} />}
                {isSuperUser && <Route path="/setup/durezza" component={DurezzaArea} />}
                {isSuperUser && <Route path="/setup/finevita" component={FinevitaArea} />}
                {isSuperUser && <Route path="/setup/formato" component={FormatoArea} />}
                {isSuperUser && <Route path="/setup/finitura" component={FinituraArea} />}
                {isSuperUser && <Route path="/setup/lucentezza" component={LucentezzaArea} />}
                {isSuperUser && <Route path="/setup/tag" component={TagArea} />}
                {isSuperUser && <Route path="/setup/tecnologia" component={TecnologiaArea} />}
                {isSuperUser && <Route path="/setup/texture" component={TextureArea} />}
                {isSuperUser && <Route path="/setup/trasparenza" component={TrasparenzaArea} />}
                {isSuperUser && <Route path="/setup/tipologia" component={TipologiaArea} />}
                <Route path="/progetti/confronto" component={ProgettiConfronto} />
                {/*isSuperUser && <Route path="/rapido" component={ChartJs} />*/}
                {/*<Route path="/materialematrec" component={MatrecArea} />*/}
                <Route path="/progetto/:id/:action" component={ProgettoAction} />
                <Route path="/progetto/:id" component={ProgettoArea} />
                <Route path="/progetto" component={ProgettoArea} />
                <Route path="/logo" component={LogoArea} />
                <Route path="/progettot" component={ProgettoAreaT} />

                <Route path="/aziendacliente" component={AziendaClienteArea} />

                <Route path="/materialematrec" component={MatrecArea2} />
                <Route path="/materialecliente" component={MatClienteArea} />
                <Route path="/setup/importazione" component={ImportazioneArea} />
                <Route path="/specifiche/materie-prime-critiche" component={Specifiche4} />
                <Route path="/specifiche/3" component={Specifiche3} />
                <Route path="/specifiche/2" component={Specifiche2} />
                <Route path="/specifiche" component={Specifiche1} />
                <Route path="/categorieiva" component={CategoriaIvaArea} />
                <Route path="/ft" component={FtArea} />
                <Route path="/prodotti" component={ProdottoArea} />
                <Route path="/ordini" component={OrdineArea} />
                <Route path="/fatture" component={FattureArea} />
                <Route path="/fatturepags" component={PagamentoGruppoArea} />
                <Route path="/ecconf" component={EcConfArea} />
                <Route path="/" component={readonly ? MatrecArea2 : ProgettoArea} />
            </Switch>
        </Suspense>
    );
}

export default Homepage;